import type {SlButton} from "@shoelace-style/shoelace/shoelace";

export function queryFormSubmitElements(form: HTMLFormElement): Array<HTMLElement> {
    const actualTriggers: Array<HTMLElement> = [];

    const potentialTriggers = form.querySelectorAll<HTMLElement>('button, input, sl-button');
    for (const potentialTrigger of potentialTriggers) {
        if (isSubmitTrigger(potentialTrigger)) {
            actualTriggers.push(potentialTrigger);
        }
    }

    const formId = form.getAttribute('id');

    if (formId !== null) {
        const potentialOuterFormTriggers = document.querySelectorAll<HTMLElement>('button[form="'+formId+'"], input[form="'+formId+'"], sl-button[form="'+formId+'"]');
        for (const potentialTrigger of potentialOuterFormTriggers) {
            if (isSubmitTrigger(potentialTrigger)) {
                actualTriggers.push(potentialTrigger);
            }
        }
    }

    return actualTriggers;
}

function isSubmitTrigger(element: HTMLElement) {
    if (element instanceof HTMLButtonElement || element instanceof HTMLInputElement) {
        return element.type === 'submit';
    }

    if (element.tagName === 'SL-BUTTON') {
        if (customElements.get('SL-BUTTON')) {
            return (element as SlButton).type === 'submit';
        }

        /**
         * Wenn der SlButton noch nicht als Custom-Element geladen wurde, dann muss das
         * Type-Attribut geprüft werden.
         */
        return (element.getAttribute('type') ?? '').toLowerCase() === 'submit';
    }

    return false;
}
